import { render, staticRenderFns } from "./ExportMenu.vue?vue&type=template&id=3a8f7f8e&scoped=true&"
import script from "./ExportMenu.vue?vue&type=script&lang=js&"
export * from "./ExportMenu.vue?vue&type=script&lang=js&"
import style0 from "./Styles/SuperSyndicate.css?vue&type=style&index=0&id=3a8f7f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f7f8e",
  null
  
)

export default component.exports